import React from 'react'
import Widget from './Widget'
import styled from '@emotion/styled'

const Container = styled.div`
  width: calc(100vw - 120px);
  padding: 40px 0;
`

const StyledWidget = styled(Widget)`
  height: calc(100vh - 160px);
`

type Props = {
  children?: any
  style?: any
}

const TableContainer = ({ children, style }: Props) => (
  <Container style={style}>
    <StyledWidget>{children}</StyledWidget>
  </Container>
)

export default TableContainer
